import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';
import { MESSAGES, STYLE_OPTIONS } from 'src/constants';

function TCellMessageType({
  messageType,
  sendMethod = '',
  eventName = '',
  groupName = '',
  smartActionName = '',
}) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: '2px'
      }}
    >
      <Typography
        variant="body2"
      >
        {MESSAGES.SCHEDULED_MESSAGE_TYPES_LABELS?.[messageType] || messageType}
      </Typography>
      {messageType === MESSAGES.SCHEDULED_MESSAGE_TYPES.SCHEDULED_MESSAGE && (
        <Typography
          variant="body2"
          color="textSecondary"
          sx={{
            fontStyle: 'italic',
          }}
        >
          {sendMethod}
        </Typography>
      )}
      {(messageType === MESSAGES.SCHEDULED_MESSAGE_TYPES.EVENT_SMART_ACTION_MESSAGE
        || messageType === MESSAGES.SCHEDULED_MESSAGE_TYPES.GROUP_SMART_ACTION_MESSAGE)
        && (
          <>
            <Typography
              variant="subtitle2"
              sx={{
                color: STYLE_OPTIONS.COLOR_LIGHT_GREEN,
                fontWeight: 600,
                fontStyle: 'italic',
              }}
            >
              {eventName || groupName}
            </Typography>
            <Typography
              variant="body2"
              color="textSecondary"
              sx={{
                fontStyle: 'italic',
              }}
            >
              {smartActionName}
            </Typography>
          </>
        )}
    </Box>
  );
}

TCellMessageType.propTypes = {
  messageType: PropTypes.string.isRequired,
  sendMethod: PropTypes.string,
  eventName: PropTypes.string,
  groupName: PropTypes.string,
  smartActionName: PropTypes.string,
};

export default TCellMessageType;
